import {Effect} from '..';
import {AccountActions} from './';
import {buildBaseHeader} from "../../util/helper-methods";
import axios from "axios";
import {AppEffects} from "../app";

export const getAccount = (): Effect =>
  async (dispatch, getState) => {
    const rootState = getState();
    try {
      const headers = {...buildBaseHeader(rootState)};
      const response = await axios.get('/dashboard-api/get-account', {headers});
      await dispatch(AccountActions.successGetAccount(response.data));
    } catch (err) {
      // todo pass the error message from the response object to the action
      if(rootState.app.queryParams.apply === 'shopify') {
        const alertContext = btoa(JSON.stringify({
          alertComponent: {
            heading: 'Shopify Integration',
            subheading: 'Uh oh, something went wrong.',
            icon: 'warning',
            copy: 'An error occurred retrieving your account, this may affect your Shopify integration.',
            support: true,
            buttonCopy: 'Continue to Dashboard',
            buttonRedirect: '/authenticate/awaiting'
          }
        }));
        window.location.assign(`/authenticate/alert?context=${alertContext}`);
      } else {
        await dispatch(AccountActions.failedGetAccount('Error retrieving account.'));
      }

    }
  };

export const addShopifyAttributes = (): Effect =>
  async (dispatch, getState) => {
    const rootState = getState();
    try {
      const queryParams = rootState.app.queryParams;
      const account = rootState.account.accountInfo;
      const shops = rootState.account.shops;
      const isShopifyAdded = rootState.account.isShopifyAdded;

      const headers = {...buildBaseHeader(rootState)};

      if(!account) {
        await dispatch(getAccount());
        dispatch(AppEffects.handleCompletion());
      } else {
        // the shop is always going to be passed in testShop.myshopify.com format, but saved as only the name
        const shopName = queryParams.shop.split('.')[0];
        const shopExists = shops && shops.find((shop) => shop.toLowerCase() === shopName.toLowerCase());
        if (!isShopifyAdded && queryParams.shop && !shopExists) {
          await axios.put('/integrations/shopify/shop', {accountId: account.accountEid, shop: queryParams.shop}, {headers});
          await dispatch(AccountActions.successAddShopifyAttributes(queryParams.shop));
        } else {
          await dispatch(AccountActions.successAddShopifyAttributes(shopName));
        }
      }
    } catch (err) {
      await dispatch(AccountActions.failedGetAccount('Error adding Shopify data to account.'))
      // todo pass the error message from the response object to the action
      if(rootState.app.queryParams.apply === 'shopify') {
        const alertContext = btoa(JSON.stringify({
          alertComponent: {
            heading: 'Shopify Integration',
            subheading: 'Uh oh, something went wrong.',
            icon: 'warning',
            copy: err?.response?.status === 501 ? err?.response?.data?.error : 'An error occurred connecting your Shopify shop to your BitPay account, this may affect your Shopify integration.',
            support: err?.response?.status === 501 ? false : true,
            buttonCopy: 'Continue to Dashboard',
            buttonRedirect: '/authenticate/awaiting'
          }
        }));
        window.location.assign(`/authenticate/alert?context=${alertContext}`);
      }
    }
  };
